import { getKeys } from '../utils';

export enum Interface {
    Screen = 'screen',
}

export enum ImplicitSurface {
    Desktop = 'desktop',
    Mobile = 'mobile',
}
const implicitSurfaces = Object.values(ImplicitSurface) as ImplicitSurface[];
export enum Surface {
    Navigator = 'navigator',
    Station = 'station',
    Auto = 'auto',
}
const interfacesBySurface: Partial<Record<Surface, Interface[]>> = {
    [Surface.Navigator]: [],
    [Surface.Station]: [],
    [Surface.Auto]: [],
};
const surfaces = Object.values(Surface) as Surface[];
const surfaceHasInterfaces = (interfaces: Interface[]) => (surface: Surface) => {
    const surfaceInterfaces = interfacesBySurface[surface];

    return surfaceInterfaces && interfaces.every((i) => surfaceInterfaces.includes(i));
};
export const getSupportedSurfaces = (interfaces: Interface[]) => {
    return [...implicitSurfaces, ...surfaces.filter(surfaceHasInterfaces(interfaces))];
};
const isInterface = (value: string): value is Interface => {
    return Object.values<string>(Interface).includes(value);
};
export const filterInterfaces = (values: string[]) => {
    return values.filter(isInterface);
};

export const getLeastCapableSurface = (interfaces: Record<Interface, boolean>) => {
    const requiredInterfaces = getKeys(interfaces).filter((i) => interfaces[i]);
    const surfaces = getSupportedSurfaces(requiredInterfaces);

    return surfaces.includes(Surface.Station) ? Surface.Station : ImplicitSurface.Mobile;
};
